import { InvitationCode } from 'fitbeat.models';
import { IInvitationCodeRepository } from '../interfaces';
import { PouchDbQueryHelper } from './pouchdb-query-helper';

export class DbInvitationCodeRepository implements IInvitationCodeRepository {

    private db: PouchDbQueryHelper;

    constructor(private dbInvitationCode: any) {
      this.db = new PouchDbQueryHelper(this.dbInvitationCode, 'DbUserProfileRepository');
    }

    public async get(code: string): Promise<InvitationCode | null> {
        try {
            const invitationCode = await this.dbInvitationCode.get(code);
            return invitationCode;
        } catch (error) {
            if (error.status === 404) {
                return null;
            }
            throw error;
        }
    }

    public async add(invitationCode: InvitationCode): Promise<void> {
        const doc = JSON.parse(JSON.stringify(invitationCode));
        doc._id = invitationCode.code;
        await this.dbInvitationCode.put(doc);
    }

    public async update(invitationCode: InvitationCode): Promise<InvitationCode> {
        const doc = JSON.parse(JSON.stringify(invitationCode));
        await this.dbInvitationCode.put(doc);
        return invitationCode;
    }

    public async getInvitationCodesFromFamilyPlanOwner(planOwnerUserProfileId: string): Promise<InvitationCode[]> {
      const queryOptions = {
          selector: {
              'invitationCodeDetails.familyPlanDetails.planOwnerUserProfileId': planOwnerUserProfileId,
              'redeemable': true,
              'cancelled': false,
          },
        };

      const result = await this.db.queryAndGetDocs(`getAllInvitationsInFamilyPlan()`, queryOptions);

      return result;
    }

    public async cancelInvitationCode(invitationCode: InvitationCode): Promise<InvitationCode> {
      invitationCode.cancelled = true;
      return await this.dbInvitationCode.put(invitationCode);
    }
}
